document.addEventListener('DOMContentLoaded', () => {
  const bundleForm = document.getElementById('bundle-selector-form');
  if (!bundleForm) return;

  // State Object
  const state = {
    selectedProducts: {},
    totalSelected: 0,
    subtotal: 0.00,
    requiredCount: 3,
    savings: 0.00
  };

  // Initialize state with product price
  const variantCards = document.querySelectorAll('.bundle-variant__card');
  variantCards.forEach(card => {
    const variantId = card.dataset.variantId;
    const price = parseFloat(card.dataset.variantPrice);
    state.selectedProducts[variantId] = {
      quantity: 0,
      price: price
    };
  });

  const updateIndicator = () => {
    document.querySelector('.bundle-selected__product-counter span:first-child').innerText = `${state.totalSelected}`;
  };

  

  const updateSubtotal = () => {
    state.subtotal = Object.values(state.selectedProducts).reduce((total, product) => {
      return total + (product.quantity * product.price);
    }, 0);

    updateSavings();

    const subTotal = (state.subtotal / 100).toFixed(2);
    const subtotalAfterSavings = (subTotal - state.savings).toFixed(2);

    if( state.totalSelected >= state.requiredCount) {
      document.querySelector('.bundle-selector__subtotal-price').innerHTML =`$${subtotalAfterSavings}`
    } else {
      document.querySelector('.bundle-selector__subtotal-price').innerText = `$${subTotal}`;
    }
    
  };

  const updateSavings = () => {

    const savingsElement = document.querySelector('.bundle-selector__savings');
    if (!savingsElement) {
      console.error('Element .bundle-selector__savings-price not found.');
      return;
    }

    if( state.totalSelected >= state.requiredCount ) {
      const discount = 15;
      const subTotal = (state.subtotal / 100).toFixed(2);
      state.savings = ((subTotal / 100) * discount).toFixed(2);
      document.querySelector('.bundle-selector__savings-price').innerText = `$${state.savings}`
      savingsElement.style.display = 'flex';
    } else {
      savingsElement.style.display = 'none';      
    }
  }

  const updateShopNowButton = () => {
    const shopBtn = document.querySelector('.bundle-selector__shop-btn');
    shopBtn.disabled = (state.totalSelected < state.requiredCount);

    if( state.totalSelected >= state.requiredCount ) {
      shopBtn.innerText = 'Shop now';
      shopBtn.classList.add('active');
      shopBtn.classList.remove('disable');
    } else {
      shopBtn.innerText = `Select ${state.requiredCount - state.totalSelected} more packs`;
      shopBtn.classList.add('disable');
      shopBtn.classList.remove('active');
    }

  };

  const toggleControls = (variantId) => {
    const card = document.querySelector(`.bundle-variant__card[data-variant-id="${variantId}"]`);
    if (state.selectedProducts[variantId].quantity > 0) {
       card.querySelector('.variant__atb-btn').style.display = 'none';
       card.querySelector('.variant__quantity-controls').style.display = 'flex';
    } else {
      card.querySelector('.variant__atb-btn').style.display = 'flex';
      card.querySelector('.variant__quantity-controls').style.display = 'none';
    }
  };


  

  const handleIncreaseClick = (variantId) => {
    if (variantId in state.selectedProducts) {
      state.selectedProducts[variantId].quantity++;
      state.totalSelected++;
      updateIndicator();
      updateSubtotal();
      updateSavings();
      updateShopNowButton();
      toggleControls(variantId);

      const card = document.querySelector(`.bundle-variant__card[data-variant-id="${variantId}"]`);
      card.querySelector('.variant__added-no').innerText = state.selectedProducts[variantId].quantity;
      card.querySelector('.variant-input').value = state.selectedProducts[variantId].quantity;
    } else {
      console.error(`Variant ID ${variantId} not found in state`);
    }
  };

  const handleDecreaseClick = (variantId) => {
    if (variantId in state.selectedProducts && state.selectedProducts[variantId].quantity > 0) {
      state.selectedProducts[variantId].quantity--;
      state.totalSelected--;
      updateIndicator();
      updateSubtotal();
      updateSavings();
      updateShopNowButton();
      toggleControls(variantId);

      const card = document.querySelector(`.bundle-variant__card[data-variant-id="${variantId}"]`);
      card.querySelector('.variant__added-no').innerText = state.selectedProducts[variantId].quantity;
      card.querySelector('.variant-input').value = state.selectedProducts[variantId].quantity;

      
    } else {
      console.error(`Variant ID ${variantId} not found in state or quantity is already 0`);
    }

  

  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {};
    formData.forEach((value, key) => {
      if (value > 0) {
        data[key] = value;
      }
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: Object.keys(data).map(variantId => ({
            id: variantId,
            quantity: parseInt(data[variantId])
          }))
        })
      });
      const result = await response.json();
      console.log('Products added to cart:', result);
      window.location.href = '/cart';
    } catch (error) {
      console.error('Error adding products to cart:', error);
    } finally {
      document.querySelector('.bundle-selector__shop-btn').innerText = "Added"
    }
  };

  document.querySelectorAll('.variant__increase-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent form submission
      const variantId = e.target.closest('.bundle-variant__card').dataset.variantId;
      handleIncreaseClick(variantId);
    });
  });

  document.querySelectorAll('.variant__decrease-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent form submission
      const variantId = e.target.closest('.bundle-variant__card').dataset.variantId;
      handleDecreaseClick(variantId);
    });
  });

  document.querySelectorAll('.variant__atb-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = e.target.closest('.bundle-variant__card').dataset.variantId;
      handleIncreaseClick(variantId);
    });
  })

  bundleForm.addEventListener('submit', handleFormSubmit);

});
